import React from 'react';
import { Shield, Truck, Heart } from 'lucide-react';

export const BenefitGrid = () => {
  const benefits = [
    {
      icon: <Shield size={32} />,
      title: "Uncompromising Sourcing and Purity",
      desc: "We don't cut corners. Our Ankoro is sourced directly from indigenous harvesters in the Congo. Every batch is checked to ensure it is free from synthetic additives, ensuring you receive only 100% natural African botanicals."
    },
    {
      icon: <Truck size={32} />,
      title: "Privacy-First UK Shipping",
      desc: "We understand that discretion is paramount. All orders are dispatched in plain, unbranded packaging. Whether it is delivered to your home or office, only you will know the power contained within."
    },
    {
      icon: <Heart size={32} />,
      title: "Expertise and Heritage",
      desc: "We combine centuries of African tradition with modern quality standards. Our team understands the unique pressures faced by men in the UK today and provides the natural solutions required to overcome them."
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <span className="text-simba-green font-bold text-sm uppercase tracking-widest block mb-2">
            Why the UK Pride Trusts Simba Herbals
          </span>
          <h2 className="font-display text-4xl text-simba-dark">
            Trusted by Kings
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {benefits.map((item, i) => (
            <div key={i} className="group p-8 rounded-2xl bg-simba-cream hover:bg-simba-green transition-colors duration-500 text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white text-simba-green group-hover:text-simba-green group-hover:shadow-lg mb-6 transition-all transform group-hover:-translate-y-2">
                {item.icon}
              </div>
              <h3 className="font-display font-bold text-xl mb-3 text-simba-dark group-hover:text-white transition-colors">
                {item.title}
              </h3>
              <p className="text-gray-600 group-hover:text-simba-lime/90 transition-colors leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
